/***
 * @Author: ZhaoG
 * @Date: 2025-04-09 10:57:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-12-08 08:56:56
 * @FilePath: \eva-fe\src\app\sourcingFlow\api\expertEvaluation.js
 * @Description:
 */
/**
 *@author       罗朝军
 *@date         2021/9/15 20:14
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";
// import blobRequest from "@/config/utils/requestBlob";

// 用于专家评标项目列表查询。
export function qryExpertEvaProjectListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryExpertEvaProjectList",
    method: method,
    data
  });
}

// 用于评标准备详情查询
export function qryBidEvaPrepareDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidEvaPrepareDetail",
    method: method,
    data
  });
}

// 用于评标专家列表查询
export function qryJoinExpertListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryJoinExpertList",
    method: method,
    data
  });
}
//招标文件
export function qryAiBidDocument(data) {
  return request({
    url: "/apis/bid/smc/qryAiBidDocument",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//投标文件查询
export function qryAiQuoteDocument(data) {
  return request({
    url: "/apis/bid/smc/qryAiQuoteDocument",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
//试点单位
export function checkPilotCompany(data) {
  return request({
    url: "/apis/bid/smc/checkPilotCompany",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//招投标文件上传
export function runAiBidClearTask(data) {
  return request({
    url: "/apis/bid/smc/runAiBidClearTask",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//清表地址
export function getAiClearAddress(data) {
  return request({
    url: "/apis/bid/smc/getAiClearAddress",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

// 用于专家签到记录列表查询。
export function qryExpertSignListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryExpertSignList",
    method: method,
    data
  });
}

// 专家签到
export function dealExpertSignApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertSign",
    method: method,
    data
  });
}

// 用于专家签到。
export function dealExpertWechatSignApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertWechatSign",
    method: method,
    data
  });
}

// 用于专家承诺书查询
export function qryExpertCommitmentApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryExpertCommitment",
    method: method,
    data
  });
}

// 用于专家承诺书同意
export function dealExpertCommitmentApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertCommitment",
    method: method,
    data
  });
}

// 专家评分表制定
export function dealExpertScoreFormulateApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertScoreFormulate",
    method: method,
    data
  });
}

// 供应商符合性检查列表查询
export function qrySupComCheckListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupComCheckList",
    method: method,
    data
  });
}

// 查询符合性检查-供应商关联关系检查数据new
export function querySupComRelationCheckNew(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/querySupComRelationCheckNew",
    method: method,
    data
  });
}

// 查询ai符合性检查列表数据
export function querySupAiReviewList(data, method = "POST") {
  return request({
    url: "/apis/bid/bidc/querySupAiReviewList",
    method: method,
    data
  });
}

// 保存ai符合性检查数据
export function dealSupComRelationCheckSaveNew(data, method = "POST") {
  return request({
    url: "/apis/bid/bidc/dealSupComRelationCheckSaveNew",
    method: method,
    data
  });
}

// 供应商符合性检查保存
export function dealSupComCheckSaveApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealSupComCheckSave",
    method: method,
    data
  });
}

// 用于供应商符合性检查专家确认列表查询
export function qrySupComCheckConfirmListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupComCheckConfirmList",
    method: method,
    data
  });
}

// 用于供应商符合性检查确认详情查询
export function qrySupComCheckConfirmDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupComCheckConfirmDetail",
    method: method,
    data
  });
}

// 用于供应商符合性检查确认
export function dealSupComCheckConfirmApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealSupComCheckConfirm",
    method: method,
    data
  });
}

// 用于供应商符合性检查生效
export function dealSupComCheckEffectApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealSupComCheckEffect",
    method: method,
    data
  });
}

// 用于专家评分包件分类查询
export function qryExpertScorePackListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryExpertScorePackList",
    method: method,
    data
  });
}

// 用于专家供应商报价待评分列表查询
export function qryExpertSupPackQuoteToScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryExpertSupPackQuoteToScore",
    method: method,
    data
  });
}

// 用于专家供应商报价评分列表查询
export function qryExpertSupPackQuoteScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryExpertSupPackQuoteScore",
    method: method,
    data
  });
}

// 用于专家供应商评分
export function dealExpertSupScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertSupScore",
    method: method,
    data
  });
}

// 用于专家供应商评分提交
export function dealExpertSupScoreSubmitApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertSupScoreSubmit",
    method: method,
    data
  });
}

// 用于查询采购方案详情包件
export function queryPurchaseSchemePackageApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/queryPurchaseSchemePackage",
    method: method,
    data
  });
}

// 用于查询采购方案包件详情并看是否分包
export function listPurchaseSchemePackageApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/listPurchaseSchemePackage",
    method: method,
    data
  });
}

// 用于评分汇总查询
export function qrySumScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySumScore",
    method: method,
    data
  });
}

// 用于评分汇总包件列表查询
export function qrySumScorePackListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySumScorePackList",
    method: method,
    data
  });
}

// 用于评分汇总专家打分列表查询
export function qrySumScoreExpertScoreListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySumScoreExpertScoreList",
    method: method,
    data
  });
}

// 用于专家供应商评分撤销
export function dealExpertSupScoreCancelApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealExpertSupScoreCancel",
    method: method,
    data
  });
}

// 用于评分汇总计算查询
export function qrySumScoreCalculateApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySumScoreCalculate",
    method: method,
    data
  });
}

// 用于评分汇总保存  传purStep: "080607",打分汇总保存
export function dealSumScoreSaveApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealSumScoreSave",
    method: method,
    data
  });
}

// 用于评分汇总提交
export function dealSumScoreSubmitApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealSumScoreSubmit",
    method: method,
    data
  });
}

// 用于未提交评分专家列表查询
export function qryNotSubmitScoreExpertListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryNotSubmitScoreExpertList",
    method: method,
    data
  });
}

// 用于评标报告详情查询。
export function qryBidReportDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidReportDetail",
    method: method,
    data
  });
}

// 用于供应商投标文件批量下载信息查询
export function qrySupBiddingFileInfoListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupBiddingFileInfoList",
    method: method,
    data
  });
}

// 用于附件查询
export function qryFileinfoListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryFileinfoList",
    method: method,
    data
  });
}

// 用于附件查询
export function qryFileinfoListForEva(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryFileinfoListForEva",
    method: method,
    data
  });
}

// 用于评标报告保存
export function dealBidReportSaveApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidReportSave",
    method: method,
    data
  });
}

// 用于评标报告提交确认
export function dealBidReportSubmitApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidReportSubmit",
    method: method,
    data
  });
}

// 用于评标报告专家确认列表查询
export function qryBidReportExpertConfirmListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidReportExpertConfirmList",
    method: method,
    data
  });
}

// 用于评标报告推荐列表查询
export function qryBidReportRecommendListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidReportRecommendList",
    method: method,
    data
  });
}

// 用于评标报告生效
export function dealBidReportEffectApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidReportEffect",
    method: method,
    data
  });
}

// 用于评标报告专家确认
export function dealBidReportExpertConfirmApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidReportExpertConfirm",
    method: method,
    data
  });
}

// 当前一轮供应商报价信息查询
export function qryCurrentRoundSupPriceApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryCurrentRoundSupPrice",
    method: method,
    data
  });
}

// 用于投标供应商列表查询
export function qryBidPriceSupListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidPriceSupList",
    method: method,
    data
  });
}

// 用于查询采购方案详情
export function queryPurchaseSchemeDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/queryPurchaseSchemeDetail",
    method: method,
    data
  });
}

// 用于供应商澄清列表查询
export function qrySupClearNoticeListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupClearNoticeList",
    method: method,
    data
  });
}

// 用于公告详情查询
export function qryNoticeDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryNoticeDetail",
    method: method,
    data
  });
}

// 用于公告发布。
export function dealClearNoticeSendApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealClearNoticeSend",
    method: method,
    data
  });
}

// 用于评分表查询。
export function qryScoreListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryScoreList",
    method: method,
    data
  });
}

// 供应商关联关系
export function getWarningRelationshipList(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/getWarningRelationshipList",
    method: method,
    data
  });
}

// 用于投标准备详情查询.
export function qryBidPricePrepareApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidPricePrepare",
    method: method,
    data
  });
}

// 用于开始专家评标
export function dealBidEvaStartApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidEvaStart",
    method: method,
    data
  });
}

// 用于专家评标菜单列表查询
export function listBidEvaMenuApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/listBidEvaMenu",
    method: method,
    data
  });
}

// 用于评分模板列表查询.
export function qryScoreTemplateListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryScoreTemplateList",
    method: method,
    data
  });
}

// 用于评分模板新增.
export function dealScoreTemplateOperateApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealScoreTemplateOperate",
    method: method,
    data
  });
}

// 用于评分评分模板删除
export function dealScoreTemplateDeleteApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealScoreTemplateDelete",
    method: method,
    data
  });
}

// 用于评分模板详情查询.
export function qryScoreTemplateDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryScoreTemplateDetail",
    method: method,
    data
  });
}

// 用于专家评标环节状态查询
export function qryBidEvaProcessStatusApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidEvaProcessStatus",
    method: method,
    data
  });
}

// 用于已报名供应商下拉列表查询
export function qryJoinSupSelectListApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryJoinSupSelectList",
    method: method,
    data
  });
}

// 用于供应商报价详情查询。
export function qrySupBidPriceDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupBidPriceDetail",
    method: method,
    data
  });
}
// 用于快结婚供应商报价详情查询。
export function qrySupBidPriceDetailKJApi(data, method = "POST") {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_LS_URL) +
      "/apis/sclma/bid/bidc/qrySupBidPriceDetail",
    method: method,
    data
  });
}

// 用于供应商报价信息查询
export function qrySupBidPriceInfoApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySupBidPriceInfo",
    method: method,
    data
  });
}

// 文件压缩批量下载
export function batchDownloadByUploadIdsApi(data, method = "POST") {
  return request({
    url: "apis/bid/oss/batchDownloadByUploadIds",
    method: method,
    data
  });
}

// 用于评标报告专家确认详情查询
export function qryBidReportExpertConfirmDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qryBidReportExpertConfirmDetail",
    method: method,
    data
  });
}

// 用于评分环节统一前置校验
export function dealBidEvaCheckApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidEvaCheck",
    method: method,
    data
  });
}

// 用于判断专家是否是首次签到。
export function checkExpertFirstSignApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/checkExpertFirstSign",
    method: method,
    data
  });
}

// 查询机构用户详情
export function getEmpInfoApi(data, method = "POST") {
  return request({
    url: "apis/bid/org/getEmpInfo",
    method: method,
    data
  });
}

// 符合性检查
export function SupComRelationCheckSave(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealSupComRelationCheckSave",
    method: method,
    data
  });
}

// 符合性检查详情页
export function SupComRelationCheck(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/querySupComRelationCheck",
    method: method,
    data
  });
}

// 符合性检查详情页
export function companyDetail(data, method = "POST") {
  return request({
    url: "apis/bid/smpc/relationship",
    method: method,
    data
  });
}
// 删除附件
export function delFileInfo(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/delFileInfo",
    method: method,
    data
  });
}

export function savefile(data) {
  return request({
    url: "apis/bid/oss/savefile",
    method: "POST",
    data
  });
}

// 供应商联系人预警查询接口
export function bidSupPersonnelRelationWarning(data) {
  return request({
    url: "apis/bid/bidc/bidSupPersonnelRelationWarning",
    method: "post",
    data
  });
}

export function qrySumScoreSupScoreDetail(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/qrySumScoreSupScoreDetail",
    method: method,
    data
  });
}

export function supComCheckDetailMobilePdfExport(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/supComCheckDetailMobilePdfExport",
    method: method,
    data
  });
}

//采购风险评分查询。
export function queryPurchaseRiskScoreList(data) {
  return request({
    url: "/apis/bid/bidc/queryPurchaseRiskScoreList",
    method: "post",
    data
  });
}

//采购风险评分更新。
export function dealPurchaseRiskScore(data) {
  return request({
    url: "/apis/bid/bidc/dealPurchaseRiskScore",
    method: "post",
    data
  });
}

//下载。
export function download(data) {
  return request({
    url: "/apis/bid/bidc/downloadReport",
    method: "post",
    data
  });
}

// //下载。
// export function download(data) {
//   return blobRequest({
//     url: "/apis/bid/bidc/download",
//     responseType: "blob",
//     method: "post",
//     data
//   });
// }

export function batchDownloadEvaReport(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/batchDownloadEvaReport",
    method: method,
    data
  });
}

// 用于评标判断专家是否签名
export function dealBidEvaSignPictureCheckApi(data, method = "POST") {
  return request({
    url: "apis/bid/bidc/dealBidEvaSignPictureCheck",
    method: method,
    data
  });
}

export function getSchemePackList(data) {
  return request({
    url: "/apis/bid/bidc/getSchemePackList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
// 上传附件校验
export function uploadFileCheck(data) {
  return request({
    url: "/apis/bid/oss/uploadFileCheck",
    method: "post",
    data
  });
}
// token
export function getAiToken(data) {
  return request({
    url: "/apis/bid/bidc/getAiToken?secret=",
    method: "post",
    data
  });
}
// 试点单位
export function querySmpcOrgOpenConfig(data) {
  return request({
    url: "/apis/bid/org/querySmpcOrgOpenConfig",
    method: "post",
    data
  });
}
// 评标报告下载
export function getReportFileUrl(data) {
  return request({
    url: "/apis/bid/bidc/getReportFileUrl?schemeId=" + data.schemeId,
    method: "post",
    data
  });
}
